export const createShader = (
    gl,
    src,
    type,
) => {
    var shader = gl.createShader(type);
    if (shader) {
        gl.shaderSource(shader, src);
        gl.compileShader(shader);
        const message = gl.getShaderInfoLog(shader);
        if (message && message.length > 0) {
            console.error(message);
        }
        return shader;
    }
};

export const createProgram = (
    gl,
    vert,
    frag,
) => {
    const vertShader = createShader(gl, vert, gl.VERTEX_SHADER);
    const fragShader = createShader(gl, frag, gl.FRAGMENT_SHADER);

    var program = gl.createProgram();

    if (program && vertShader && fragShader) {
        gl.attachShader(program, vertShader);
        gl.attachShader(program, fragShader);
        gl.linkProgram(program);
        gl.validateProgram(program);

        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
            const info = gl.getProgramInfoLog(program);
            console.error(`Could not compile WebGL program. \n\n${info}`);
        }

        return program;
    }
};
